export const FirebaseConfig = {
	"projectId": "hellotaxi-cbda1",
	"appId": "1:979331850861:web:c36df4f5f9ab6bf4661564",
	"databaseURL": "https://hellotaxi-cbda1-default-rtdb.firebaseio.com",
	"storageBucket": "hellotaxi-cbda1.firebasestorage.app",
	"apiKey": "AIzaSyDMU259xr1ZoDuBsO3dS-s1t_q9ymNnGsE",
	"authDomain": "hellotaxi-cbda1.firebaseapp.com",
	"messagingSenderId": "979331850861",
	"measurementId": "G-SP6G0267HZ",
	"projectNumber": "979331850861",
	"version": "2"
};